import script from "./DrawerCardSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawerCardSelector.vue?vue&type=script&setup=true&lang=ts"

import "./DrawerCardSelector.vue?vue&type=style&index=0&id=0284cbc0&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0284cbc0"]])

export default __exports__